import { Checkbox, Input, Select } from "antd";
import { memo, useState } from "react";
import { svg } from "../../../../Assets/svg";
import { calculateAll } from "./aprAutoCalculations";
import {
  beamLevelsOptions,
  boltsOptions,
  connectionOptions,
  connectionStyleOptions,
  crossSectionOptions,
  heavyProfileOptions,
  loadTypeOptions,
  profileMenuOptions,
  profileOptions,
} from "./aprAutoData";
import { generateExcel } from "./aprAutoExcel";

const getProfileLabel = (id: number) =>
  profileOptions.find((o) => o.value === id)?.label || `Uprights ${id}`;

const getCrossSectionLabel = (id: number) =>
  crossSectionOptions.find((o) => o.value === id)?.label ||
  `Cross-Section ${id}`;

const getHeavyProfileLabel = (id: number) =>
  heavyProfileOptions.find((o) => o.value === id)?.label ||
  `Heavy Uprights ${id}`;

const range = (start: number, end: number) =>
  Array.from({ length: end - start + 1 }, (_, i) => start + i);

const StdPalletRackingAuto = () => {
  const [edit1, setEdit1] = useState("");
  const [edit2, setEdit2] = useState("");
  const [edit3, setEdit3] = useState("1.5");
  const [edit6, setEdit6] = useState("");
  const [edit7, setEdit7] = useState("");
  const [edit11, setEdit11] = useState("");
  const [edit12, setEdit12] = useState("");
  const [edit13, setEdit13] = useState("");
  const [popupmenu2, setPopupmenu2] = useState(1);
  const [popupmenu3, setPopupmenu3] = useState(1);
  const [popupmenu5, setPopupmenu5] = useState(1);
  const [popupmenu6, setPopupmenu6] = useState(1);
  const [popupmenu11, setPopupmenu11] = useState(1);
  const [reinforChecked, setReinforChecked] = useState(false);
  const [heavyChecked, setHeavyChecked] = useState(false);
  const [toExcel, setToExcel] = useState(false);
  const [optionsMenu, setOptionsMenu] = useState(1);
  const [out, setOut] = useState<any>(null);
  const [groupedResults, setGroupedResults] = useState<any>(null);
  const [top3Results, setTop3Results] = useState<any[]>([]);

  const getBestResults = (dataArray: any[]) => {
    const TARGET = 90;

    return dataArray
      .filter((item) => {
        const firstComboLoad = item.combos?.[0]?.result?.text10;
        const load = parseFloat(firstComboLoad);
        return !isNaN(load) && load <= TARGET;
      })
      .sort((a, b) => {
        const loadA = parseFloat(a.combos[0].result.text10);
        const loadB = parseFloat(b.combos[0].result.text10);
        return loadB - loadA;
      })
      .slice(0, 3);
  };

  const handleCalculate = () => {
    setOut(null);
    setGroupedResults(null);
    setTop3Results([]);

    const enforcedEdit2 = toExcel ? "NaN" : edit2;

    const crossBeams = [
      5, 6, 7, 9, 10, 12, 13, 14, 16, 17, 19, 20, 22, 23, 24, 25, 26, 27, 28,
      29, 31, 33, 35, 37, 39, 41,
    ];

    // const baseProfiles = range(2, 24);
    const baseProfilesOptionAll = [3, 4, 6, 7, 11, 13, 14, 16, 20, 21, 23, 24];
    const baseProfilesOption1 = [3, 4, 11, 13, 20, 21, 23, 24];
    const baseProfilesOption2 = [6, 7, 14, 16];
    const baseProfiles =
      Number(optionsMenu) === 3
        ? baseProfilesOption2
        : Number(optionsMenu) === 2
          ? baseProfilesOption1
          : baseProfilesOptionAll;

    // const heavyProfiles = range(2, 21);
    const heavyProfilesOptionAll = [3, 4, 6, 7, 11, 13, 14, 16, 20, 21];
    const heavyProfilesOption1 = [3, 4, 11, 13, 20, 21];
    const heavyProfilesOption2 = [6, 7, 14, 16];
    const heavyProfiles =
      Number(optionsMenu) === 3
        ? heavyProfilesOption2
        : Number(optionsMenu) === 2
          ? heavyProfilesOption1
          : heavyProfilesOptionAll;

    const profileCombinations = baseProfiles.flatMap((bp) =>
      crossBeams.flatMap((cb) => {
        return [
          {
            baseProfile: bp,
            heavyProfile: 1,
            crossBeam: cb,
            heavyMode: false,
          },
        ];
      }),
    );

    const heavyProfileCombinations = heavyProfiles.flatMap((hp) =>
      crossBeams.flatMap((cb) => {
        return [
          {
            baseProfile: 2,
            heavyProfile: hp,
            crossBeam: cb,
            heavyMode: true,
          },
        ];
      }),
    );

    const combinations = heavyChecked
      ? heavyProfileCombinations
      : profileCombinations;

    const buildInputs = (c: any) => ({
      edit1,
      edit2: enforcedEdit2,
      edit3,
      edit6,
      edit7,
      edit11,
      edit12,
      edit13,
      popupmenu1: c.baseProfile,
      popupmenu2,
      popupmenu3,
      popupmenu5,
      popupmenu6,
      popupmenu9: c.crossBeam,
      popupmenu11,
      popupmenu16: c.heavyProfile,
      reinforChecked,
      heavyChecked: c.heavyMode,
      toExcel,
    });

    const results = combinations.map((combo) => {
      try {
        return {
          ...combo,
          baseProfileLabel: getProfileLabel(combo.baseProfile),
          crossBeamLabel: getCrossSectionLabel(combo.crossBeam),
          heavyProfileLabel: getHeavyProfileLabel(combo.heavyProfile),
          result: calculateAll(buildInputs(combo)),
        };
      } catch (err) {
        return {
          ...combo,
          baseProfileLabel: getProfileLabel(combo.baseProfile),
          crossBeamLabel: getCrossSectionLabel(combo.crossBeam),
          heavyProfileLabel: getHeavyProfileLabel(combo.heavyProfile),
          result: {
            text3: "0.00",
            warnings: [`Calculation Error: ${String(err)}`],
            technical: null,
          },
        };
      }
    });

    setOut(results);

    if (!results || results.length === 0) {
      setGroupedResults([]);
      setTop3Results([]);
    }

    const groups = new Map();

    if (heavyChecked) {
      results.forEach((combo) => {
        const key = combo.heavyProfile;
        const label = getHeavyProfileLabel(combo.heavyProfile);
        if (!groups.has(key)) groups.set(key, { label, combos: [] });
        groups.get(key).combos.push(combo);
      });
    } else {
      results.forEach((combo) => {
        const key = combo.baseProfile;
        const label = getProfileLabel(combo.baseProfile);
        if (!groups.has(key)) groups.set(key, { label, combos: [] });
        groups.get(key).combos.push(combo);
      });
    }

    const groupR = Array.from(groups.entries())
      .map(([key, val]) => ({ key, label: val.label, combos: val.combos }))
      .sort((a, b) => Number(a.key) - Number(b.key));

    setGroupedResults(groupR);
    const bestThree = getBestResults(groupR);
    setTop3Results(bestThree);
  };

  const handleDownloadExcel = () => {
    if (!out || out.length === 0) return;

    const constantInputs = {
      edit1,
      edit3,
      edit6,
      edit7,
      edit11,
      edit12,
      edit13,
      popupmenu2: connectionOptions?.find((item) => item?.value === popupmenu2)
        ?.label,
      popupmenu3: boltsOptions?.find((item) => item?.value === popupmenu3)
        ?.label,
      popupmenu5: connectionStyleOptions?.find(
        (item) => item?.value === popupmenu5,
      )?.label,
      popupmenu6: popupmenu6 === 1 ? ">1" : "=1",
      popupmenu11: loadTypeOptions?.find((item) => item?.value === popupmenu11)
        ?.label,
      reinforChecked,
      heavyChecked,
      "Total Load on Racking": toExcel ? "NaN" : edit2,
    };

    const payload = {
      constantInputs: constantInputs,
      top3Results: top3Results,
    };

    generateExcel(payload, "std_pallet_racking_auto_results.xlsx");
  };

  const disabledWhenTFF = (extra = false) => toExcel || extra;

  return (
    <div className="p-4">
      <div className="row gy-3 page-form mb-3">
        <div className="col-lg-3 col-md-4 col-sm-6">
          <div className="form-item">
            <label className="custom-label mb-1 ff">Uprights Options</label>
            <Select
              placeholder="Uprights Options"
              onChange={(e) => {
                setOptionsMenu(e);
              }}
              optionFilterProp="children"
              popupClassName="user-dropdown"
              virtual={false}
              suffixIcon={svg?.selectDownArrow}
              options={profileMenuOptions}
              value={optionsMenu}
            />
          </div>
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">First Beam Level (mm)</label>
          <Input
            name="first-beam-level"
            className="form-control form-control-lg"
            disabled={disabledWhenTFF()}
            value={edit1}
            onChange={(e) => setEdit1(e.target.value)}
            placeholder="0"
            type="number"
          />
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <div className="form-item">
            <label className="custom-label mb-1 ff">Joint Type</label>
            <Select
              placeholder="Joint Type"
              onChange={(e) => setPopupmenu2(e)}
              optionFilterProp="children"
              popupClassName="user-dropdown"
              virtual={false}
              suffixIcon={svg?.selectDownArrow}
              options={connectionOptions}
              value={popupmenu2}
            />
          </div>
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <div className="form-item">
            <label className="custom-label mb-1 ff">Bolts per ft</label>
            <Select
              placeholder="Bolts per ft"
              onChange={(e) => setPopupmenu3(e)}
              optionFilterProp="children"
              popupClassName="user-dropdown"
              virtual={false}
              suffixIcon={svg?.selectDownArrow}
              options={boltsOptions}
              value={popupmenu3}
            />
          </div>
        </div>
      </div>

      <div className="row gy-3 page-form mb-3">
        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">FOS (Factor of Safety)</label>
          <Input
            name="fos-input"
            className="form-control form-control-lg"
            disabled={disabledWhenTFF()}
            value={edit3}
            onChange={(e) => setEdit3(e.target.value)}
            placeholder="0"
            type="number"
          />
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">Total Load on Racking</label>
          <Input
            name="total-load"
            className="form-control form-control-lg"
            disabled={disabledWhenTFF()}
            value={edit2}
            onChange={(e) => setEdit2(e.target.value)}
            placeholder="0"
            type="number"
          />
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <div className="form-item">
            <label className="custom-label mb-1 ff">Single Bay</label>
            <Select
              placeholder="Single Bay"
              onChange={(e) => setPopupmenu5(e)}
              optionFilterProp="children"
              popupClassName="user-dropdown"
              virtual={false}
              suffixIcon={svg?.selectDownArrow}
              options={connectionStyleOptions}
              value={popupmenu5}
            />
          </div>
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <div className="form-item">
            <label className="custom-label mb-1 ff">Beam Levels</label>
            <Select
              placeholder="Beam Levels"
              onChange={(e) => setPopupmenu6(e)}
              optionFilterProp="children"
              popupClassName="user-dropdown"
              virtual={false}
              suffixIcon={svg?.selectDownArrow}
              options={beamLevelsOptions}
              value={popupmenu6}
            />
          </div>
        </div>
      </div>

      <div className="row gy-3 page-form mb-3">
        <div className="col-lg-3 col-md-4 col-sm-6">
          <Checkbox
            checked={reinforChecked}
            onChange={(e) => setReinforChecked(e.target.checked)}
            className="fw-bold fs-6 custom-checkbox"
          >
            Reinforcement
          </Checkbox>
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <Checkbox
            checked={heavyChecked}
            onChange={(e) => setHeavyChecked(e.target.checked)}
            className="fw-bold fs-6 custom-checkbox"
          >
            Use Heavier Uprights
          </Checkbox>
        </div>
      </div>

      <div className="row gy-3 page-form mb-3">
        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">Other Beam Spacings</label>
          <Input
            name="beam-spacings"
            className="form-control form-control-lg"
            disabled={disabledWhenTFF()}
            value={edit12}
            onChange={(e) => setEdit12(e.target.value)}
            placeholder="0"
            type="number"
          />
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">Total Load on Level</label>
          <Input
            name="total-load-level"
            className="form-control form-control-lg"
            disabled={disabledWhenTFF()}
            value={edit13}
            onChange={(e) => setEdit13(e.target.value)}
            placeholder="0"
            type="number"
          />
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">Cross-Beam Width</label>
          <Input
            name="cross-beam-width"
            className="form-control form-control-lg"
            disabled={disabledWhenTFF()}
            value={edit6}
            onChange={(e) => {
              setEdit6(e.target.value);
              setEdit7((Number(e.target.value) / 200).toString());
            }}
            placeholder="0"
            type="number"
          />
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">Deflection</label>
          <Input
            name="deflection-input"
            className="form-control form-control-lg"
            disabled={disabledWhenTFF()}
            value={edit7}
            onChange={(e) => setEdit7(e.target.value)}
            placeholder="0"
            type="number"
          />
        </div>
      </div>

      <div className="row gy-3 page-form mb-3">
        <div className="col-lg-3 col-md-4 col-sm-6">
          <div className="form-item">
            <label className="custom-label mb-1 ff">Type of Loads</label>
            <Select
              placeholder="Type of Loads"
              onChange={(e) => setPopupmenu11(e)}
              optionFilterProp="children"
              popupClassName="user-dropdown"
              virtual={false}
              suffixIcon={svg?.selectDownArrow}
              options={loadTypeOptions}
              value={popupmenu11}
            />
          </div>
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">Young's Modulus (GPa)</label>
          <Input
            name="youngs-modulus"
            className="form-control form-control-lg"
            disabled={disabledWhenTFF()}
            value={edit11}
            onChange={(e) => setEdit11(e.target.value)}
            placeholder="0"
            type="number"
          />
        </div>
      </div>

      <div className="row mt-md-4 mt-3 gy-2">
        <div className="col-md-auto col-sm-6">
          <button
            onClick={handleCalculate}
            className="btn btn-lg btn-primary px-4 w-100"
          >
            CALCULATE NOW
          </button>
        </div>
        <div className="col-md-auto col-sm-6">
          <button
            onClick={handleDownloadExcel}
            disabled={!out}
            className="btn btn-lg btn-primary px-4 w-100"
          >
            DOWNLOAD EXCEL
          </button>
        </div>
      </div>

      <hr className="opacity-100 mb-4" />

      <h3>Results — Top 3 Uprights</h3>
      {!out || out.length === 0 ? (
        <p className="custom-label text-949494">
          No results — press CALCULATE NOW.
        </p>
      ) : (
        <div>
          {top3Results.length > 0 ? (
            top3Results.map((group: any) => (
              <div
                key={String(group.key)}
                className="mb-2 mt-4 border border-gray-200 rounded-md overflow-hidden shadow-sm bg-white"
              >
                <details className="group">
                  <summary className="p-3">
                    <span className="custom-label">
                      {group.label}{" "}
                      <span className="text-949494">
                        ({group.combos.length} combinations)
                      </span>
                    </span>
                  </summary>

                  <div className="px-4 pb-4">
                    {group.combos.map((combo: any, idx: any) => (
                      <ResultMini
                        key={`${group.key}-${combo.crossBeam}-${idx}`}
                        combo={combo}
                      />
                    ))}
                  </div>
                </details>
              </div>
            ))
          ) : (
            <p className="custom-label text-949494">No top uprights found.</p>
          )}

          {/* <h5 className="mb-4 mt-4">
            All Combination Results ({out.length} Calculations)
          </h5>

          {groupedResults.map((group: any) => (
            <div
              key={String(group.key)}
              className="mb-2 border border-gray-200 rounded-md overflow-hidden shadow-sm bg-white"
            >
              <details className="group">
                <summary className="p-3">
                  <span className="custom-label">
                    {group.label}{" "}
                    <span className="text-949494">
                      ({group.combos.length} combinations)
                    </span>
                  </span>
                </summary>

                <div className="px-4 pb-4">
                  {group.combos.map((combo: any, idx: any) => (
                    <ResultMini
                      key={`${group.key}-${combo.crossBeam}-${idx}`}
                      combo={combo}
                    />
                  ))}
                </div>
              </details>
            </div>
          ))} */}
        </div>
      )}
    </div>
  );
};

const ResultMini = memo(({ combo }: any) => {
  const r = combo.result || {};
  return (
    <div className="mb-2 p-3 border border-gray-100 rounded-lg bg-white shadow-sm">
      <p className="custom-label">
        {combo.heavyMode
          ? getHeavyProfileLabel(combo.heavyProfile)
          : combo.baseProfileLabel}
        <span> — </span>
        <span>{combo.crossBeamLabel}</span>
      </p>
      <div className="mt-4 d-flex justify-content-between align-items-center">
        <p className="custom-label">Frame Load (kg): {r.text3 || "0.00"}</p>
        <p className="custom-label">% Load Used: {r.text10 || "0.00"}</p>
        <p className="custom-label">Max Beam Load (kg): {r.text22 || "0.00"}</p>
        <p className="custom-label">Deflection (mm): {r.text21 || "0.00"}</p>
      </div>
      {r.warnings && r.warnings.length > 0 && (
        <div className="p-2 mt-2 rounded border custom-label text-949494">
          <span>⚠️ Warnings:</span> <span>{r.warnings.join("; ")}</span>
        </div>
      )}
    </div>
  );
});

export default StdPalletRackingAuto;
